/** LLM vendor for skill chat (`POST /api/v1/chat/stream` `provider` field). */
export type ChatLlmProvider = 'openai' | 'anthropic' | 'google';

const VALID = new Set<ChatLlmProvider>(['openai', 'anthropic', 'google']);

const COOKIE_KEY = 'ng_chat_llm_provider';
const MAX_AGE = 60 * 60 * 24 * 365; // 1 year

export function readChatLlmProviderCookie(): ChatLlmProvider | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${COOKIE_KEY}=([^;]*)`));
  if (!match) return null;
  const raw = decodeURIComponent(match[1]);
  return VALID.has(raw as ChatLlmProvider) ? (raw as ChatLlmProvider) : null;
}

export function writeChatLlmProviderCookie(provider: ChatLlmProvider) {
  document.cookie = `${COOKIE_KEY}=${encodeURIComponent(provider)}; path=/; max-age=${MAX_AGE}; SameSite=Lax`;
}
